import { render } from "./EPedidosView.vue?vue&type=template&id=6e4b9624&scoped=true"
import script from "./EPedidosView.vue?vue&type=script&lang=js"
export * from "./EPedidosView.vue?vue&type=script&lang=js"

import "./EPedidosView.vue?vue&type=style&index=0&id=6e4b9624&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4b9624"]])

export default __exports__